/**
 * conversation 领域的 GameState 分片注册（对话系统持久化快照）。
 * 由 app/gameStateSlices.ts 清单挂载；字段类型经 declare module 增补到 GameStateSlices。
 */

import { registerGameStateSlice } from '@/IsekaiRPG/modules/runtime/gameStateRegistry';
import { ConversationPersistenceStateSchema, type ConversationPersistenceState } from './types/conversationPersistence';

declare module '@/IsekaiRPG/modules/runtime/gameStateRegistry' {
  interface GameStateSlices {
    /** 对话系统持久化快照；新档缺省 */
    conversation?: ConversationPersistenceState;
  }
}

registerGameStateSlice('conversation', ConversationPersistenceStateSchema.optional());
